var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapicon = function SvgMapicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.684.8h.24a.4.4 0 0 1 .4.4v11.864a.8.8 0 0 1-.496.744l-2.904 1.208a2.401 2.401 0 0 1-.92.184h-.96c-.316 0-.628-.063-.92-.184l-3.4-1.416-3.544 1.48c-.195.08-.405.121-.616.12h-.24a.4.4 0 0 1-.4-.4V2.936a.8.8 0 0 1 .496-.744L4.324.984A2.4 2.4 0 0 1 5.244.8h.96a2.4 2.4 0 0 1 .92.184l3.4 1.416L14.068.92a1.6 1.6 0 0 1 .616-.12Zm-9.76 1.664-2.4 1V13.2l2.4-1V2.464Zm1.6 9.736V2.464l3.2 1.336v9.736l-3.2-1.336Zm4.8 1.336 2.4-1V2.8l-2.4 1v9.736Z",
    clipRule: "evenodd"
  })));
};
export default SvgMapicon;